import {
  CollapsibleGroup as DSCollapsibleGroup,
  CollapsibleGroupProps as DSCollapsibleGroupProps,
} from '@s-group/design-system-components/CollapsibleGroup/CollapsibleGroup'

export type CollapsibleGroupProps = DSCollapsibleGroupProps

export const CollapsibleGroup = (props: CollapsibleGroupProps) => {
  return <DSCollapsibleGroup {...props} />
}
